(function() {
    var pres = document.querySelectorAll('.gh-content pre');
    if (!pres.length) return;

    pres.forEach(function(pre) {
        if (pre.closest('.code-block-wrapper')) return;

        var wrapper = document.createElement('div');
        wrapper.className = 'code-block-wrapper';
        pre.parentNode.insertBefore(wrapper, pre);
        wrapper.appendChild(pre);

        var btn = document.createElement('button');
        btn.className = 'code-copy-btn';
        btn.setAttribute('aria-label', 'Copier le code');
        btn.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg>';

        btn.addEventListener('click', function() {
            var code = pre.querySelector('code');
            var text = code ? code.textContent : pre.textContent;
            navigator.clipboard.writeText(text).then(function() {
                btn.classList.add('copied');
                btn.setAttribute('aria-label', 'Copié !');
                setTimeout(function() {
                    btn.classList.remove('copied');
                    btn.setAttribute('aria-label', 'Copier le code');
                }, 2000);
            });
        });

        wrapper.appendChild(btn);
    });
})();
